export default function () {
  const widgetName = 'splashPage';
  const widgetOpts = splashPageOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: true,
      text: ''
    },
    cardWidgetLoaded: function (data, owl, hasData) {
      $(`#${widgetName} .buttonwrap a`).addClass('button');
      var isHomepage = $('body').hasClass('homepage'); // check if on homepage
      var splashcookie = Cookies.get('splash'); // check if user have the splashpage cookie
      var refSameSite = document.referrer.indexOf(SITEBASEURL) === 0; // check if user came to the homepage from an internal page
      var refRelatedSite = document.referrer.indexOf('http://design4.saffirestage.com/') === 0; // check if user came to the homepage from the relating site
      if (isHomepage && (splashcookie === undefined) && !refSameSite && !refRelatedSite) {
        $('body').prepend('<div id="splashContainer"></div>');
        
        $('#splashPage').appendTo('#splashContainer');
        $('body.homepage').css('overflow', 'hidden');
        $('body>form').css('visibility', 'hidden');
      }

      var splash = $('#splashContainer');

      function hidesplash() {
        splash.addClass('hide-splash');
        $('body.homepage').css('overflow', 'initial');
        $('body>form').css('visibility', 'visible');
        Cookies.set('splash', 'splash viewed');
        setTimeout(function () {
          splash.css('display', 'none');
        }, 300);
      }

      

      $('#splashPage .card-widget-item:last-of-type .moreButton').click(function () {
        hidesplash();
      });

      $('#splashPage .moreButton').removeAttr('target');
    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: false,
    link: [], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 2,
    moreButton: {
      visible: true,
      text: 'Enter Site'
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
    slideshow: false, // for documentation on Owl Slider: https://owlcarousel2.github.io/OwlCarousel2/docs/started-welcome.html
    slideshowOptions: {
      items: 1,
      loop: true,
      margin: 10,
      navText: ['Prev', 'Next'],
      nav: true
    },
    textOverImage: true
  });

}